export default "__VITE_ASSET__1bd7a18b__"